// import { useAuth } from '@hooks/useAuth';
import { deleteTable, get, getAll, storeTable } from "services/Tables";
import { useState } from "react";


const useTables = (table) => {
    const [isLoading, setIsLoading] = useState(false)
    const [response, setResponse] = useState([])
    const [error, setError] = useState(null)
    // const { userData } = useAuth();

    // OK
    const save = async (payload, onSuccess) => {

        setError(null)
        setIsLoading(true)

        try {
            const data = await storeTable(payload, table)

            if (data.error) {
                setError(data.data[0])
            } else {
                fetchData()
                onSuccess()
            }

            setIsLoading(false)
        } catch (error) {
            console.log(error)
            setError(error)
        } finally {
            setIsLoading(false)
        }

    }

    // OK
    const store = (payload, onSuccess) => {
        save(payload, onSuccess)
    }

    // OK
    const update = (payload, editId, onSuccess) => {
        updateTable(payload, editId, onSuccess)
    }

    // OK
    const updateTable = async (payload, editId, onSuccess) => {
        setError(null)
        setIsLoading(true)

        try {
            const data = await storeTable(payload, table, editId)

            if (data.error) {
                setError(data.data[0])
            } else {
                fetchData()
                onSuccess()
            }

            setIsLoading(false)
        } catch (error) {
            console.log(error)
            setError(error)
        } finally {
            setIsLoading(false)
        }
    }

    // OK
    const destroy = async (id) => {
        setError(null)
        setIsLoading(true)

        try {
            const data = await deleteTable(id, table)
            if (data.error) {
                setError(data.data[0])
            }

            fetchData()
            setIsLoading(false)
        } catch (error) {
            console.log(error)
            setError(error)
        } finally {
            setIsLoading(false)
        }
    }

    // Ok
    const fetchData = async (id = null, withReturn = false) => {
        setError(null)
        setIsLoading(true)

        try {
            let data;

            if (id) {
                data = await get(id, table)
                // console.log(data)
                setIsLoading(false)

                return data
            } else {
                data = await getAll(table)

                // console.log(data)

                if (withReturn) {
                    setIsLoading(false)
                    return data

                }
            }

            setResponse(data)
            setIsLoading(false)
        } catch (error) {
            console.log(error)
            setError(error)
        } finally {
            setIsLoading(false)
        }

    }

    return { response, isLoading, error, store, destroy, fetchData, update }
}


export default useTables